import script from "./confirmEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmEmail.vue?vue&type=script&setup=true&lang=js"

import "./confirmEmail.vue?vue&type=style&index=0&id=9da225a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9da225a4"]])

export default __exports__